export default __webpack_public_path__ + "static/media/digital-marketing.e74f1a38.jpg";